<div class="executed-actions__container">
  <ng-container *ngIf="!submitting; else submittingAdjustment">
    <button class="btn-gray mr-2" (click)="goBack()" mat-flat-button>
      Annuleer
    </button>
    <button class="btn-accent" (click)="submit()" mat-flat-button>
      Indienen
    </button>
  </ng-container>
  <ng-template #submittingAdjustment>
    <mat-spinner class="mr-2" color="primary" diameter="48"></mat-spinner>
  </ng-template>
</div>
